/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum CreateMemoConflictType {
  VerificationNotFound = 'verification_not_found'
}
